import React from 'react';
import { Container, Row, Col, Form, Input, Button, NavbarBrand } from 'reactstrap';
import { Link } from 'react-router-dom';
import Footer from '@components/Footer';
import RestService from '@services/REST/RestService';

class Register extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            data: {
                firstName:          { value: '', valid: true },
                lastName:           { value: '', valid: true },
                email:              { value: '', valid: true },
                company:              { value: '', valid: true },
                position:              { value: '', valid: true },
                password:           { value: '', valid: true },
                confirmPassword:    { value: '', valid: true }
            },
            validEmail: true,
            validPasswords: true
        }

        this.onSubmit = this.onSubmit.bind(this);
        this.onChange = this.onChange.bind(this);
        this.validate = this.validate.bind(this);
        this.validateEmail = this.validateEmail.bind(this);
        this.validatePasswords = this.validatePasswords.bind(this);
    }

    validateEmail() {
        const re = /\S+@\S+\.\S+/;
        return re.test(this.state.data.email.value);
    }

    validatePasswords() {
        return this.state.data.password.value === this.state.data.confirmPassword.value;
    }

    validate() {
        let formValid = true;
        this.setState(prevState => {
            for (let k in this.state.data) {
                const value = this.state.data[k].value;
                if (!value || !value.length) {
                    prevState.data[k].valid = false;
                    formValid = false;
                }
                else {
                    if (k === 'email') {
                        const validEmail = this.validateEmail();
                        prevState.validEmail = validEmail;
                        prevState.data[k].valid = validEmail;
                        if (!validEmail) formValid = false;
                    }
                    if (k === 'password') {
                        const validPasswords = this.validatePasswords();
                        prevState.validPasswords = validPasswords;
                        prevState.data[k].valid = validPasswords;
                        if (!validPasswords) formValid = false;
                    }
                }
            }
            return prevState;
        });
        return formValid;
    }

    onSubmit(e) {
        e.preventDefault();
        if (this.validate()) {
            const data = {
                first_name: this.state.data.firstName.value,
                last_name: this.state.data.lastName.value,
                email: this.state.data.email.value,
                company: this.state.data.company.value,
                job_title: this.state.data.position.value,
                password: this.state.data.password.value
            }
            RestService.register(data);
        }
    }

    onChange(e) {
        const trg = e.target;

        this.setState(prevState => {
            prevState.data[trg.name].value = trg.value;
            if (trg.name === 'email') prevState.validEmail = true;
            if (trg.name === 'password' || trg.name === 'confirmPassword') prevState.validPasswords = true;
            if (trg.value.length) prevState.data[trg.name].valid = true;
            return prevState;
        });
    }

    render() {
        return (
            <div className="simple-page">
                <header className="app-header navbar">
                    <Container className="fluid">
                        <div className="fp-top">
                            <Row>
                                <Col><NavbarBrand href="https://www.corlytics.com"></NavbarBrand></Col>
                            </Row>
                        </div>
                    </Container>
                </header>
                <Container style={{marginTop: '-70px'}}>
                    <Row>
                        <Col>
                            <div className="card" style={{marginBottom: '100px'}}>
                                <div className="card-header">Sign Up</div>
                                <div className="card-block mb-4">
                                    <Form onSubmit={this.onSubmit} className="register-form">
                                        <Row className={'mb-4' + (!this.state.data.firstName.valid ? ' register-field-error' : '')}>
                                            <Col lg={2}>First name:</Col>
                                            <Col lg={10}>
                                                <Input
                                                    value={this.state.data.firstName.value}
                                                    onChange={this.onChange}
                                                    className="form-control"
                                                    type="text"
                                                    name="firstName"
                                                />
                                                <div className="register-field-error-text">Field is required</div>
                                            </Col>
                                        </Row>
                                        <Row className={'mb-4' + (!this.state.data.lastName.valid ? ' register-field-error' : '')}>
                                            <Col lg={2}>Last name:</Col>
                                            <Col lg={10}>
                                                <Input
                                                    value={this.state.data.lastName.value}
                                                    onChange={this.onChange}
                                                    className="form-control"
                                                    type="text"
                                                    name="lastName"
                                                />
                                                <div className="register-field-error-text">Field is required</div>
                                            </Col>
                                        </Row>
                                        <Row className={'mb-4' + (!this.state.data.email.valid ? ' register-field-error' : '')}>
                                            <Col lg={2}>Email:</Col>
                                            <Col lg={10}>
                                                <Input
                                                    value={this.state.data.email.value}
                                                    onChange={this.onChange}
                                                    className="form-control"
                                                    type="text"
                                                    name="email"
                                                />
                                                {this.state.validEmail &&
                                                    <div className="register-field-error-text">Field is required</div>                                        
                                                }
                                                {!this.state.validEmail &&
                                                    <div className="register-field-error-email register-field-error-text">Please provide correct email address</div>                                    
                                                }
                                            </Col>
                                        </Row>
                                        <Row className={'mb-4' + (!this.state.data.company.valid ? ' register-field-error' : '')}>
                                            <Col lg={2}>Company:</Col>
                                            <Col lg={10}>
                                                <Input
                                                    value={this.state.data.company.value}
                                                    onChange={this.onChange}
                                                    className="form-control"
                                                    type="text"
                                                    name="company"
                                                />
                                                <div className="register-field-error-text">Field is required</div>
                                            </Col>
                                        </Row>
                                        <Row className={'mb-4' + (!this.state.data.position.valid ? ' register-field-error' : '')}>
                                            <Col lg={2}>Job title:</Col>
                                            <Col lg={10}>
                                                <Input
                                                    value={this.state.data.position.value}
                                                    onChange={this.onChange}
                                                    className="form-control"
                                                    type="text"
                                                    name="position"
                                                />
                                                <div className="register-field-error-text">Field is required</div>
                                            </Col>
                                        </Row>
                                        <Row className={'mb-4' + (!this.state.data.password.valid ? ' register-field-error' : '')}>
                                            <Col lg={2}>Password:</Col>
                                            <Col lg={10}>
                                                <Input
                                                    value={this.state.data.password.value}
                                                    onChange={this.onChange}
                                                    className="form-control"
                                                    type="password"
                                                    name="password"
                                                />
                                                {this.state.validPasswords &&
                                                    <div className="register-field-error-text">Field is required</div>
                                                }
                                                {!this.state.validPasswords &&
                                                    <div className="register-field-error-password register-field-error-text">Passwords don't match</div>
                                                }
                                            </Col>
                                        </Row>
                                        <Row className="mb-4">
                                            <Col lg={2}>Confirm password:</Col>
                                            <Col lg={10}>
                                                <Input
                                                    value={this.state.data.confirmPassword.value}
                                                    onChange={this.onChange}
                                                    className="form-control"
                                                    type="password"
                                                    name="confirmPassword"
                                                />
                                            </Col>
                                        </Row>
                                        <hr />
                                        <Row>
                                            <Col>
                                                <Link to="/login">
                                                    <button className="btn btn-secondary-new">Cancel</button>
                                                </Link>
                                            </Col>
                                            <Col className="text-right">
                                                <button type="submit" className="btn btn-primary-new">Send</button>
                                            </Col>
                                        </Row>
                                    </Form>
                                </div>
                            </div>                        
                        </Col>
                    </Row>
                </Container>
                <Footer />   
            </div>
        );
    }
}

export default Register;


// WEBPACK FOOTER //
// ./src/views/Pages/Register/Register.js